// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1MHVw","label":"LabeledBox_label__22Zpk"};